import React from 'react';
import { default as BootstrapBreadcrumb } from 'react-bootstrap/Breadcrumb';
import Container from 'react-bootstrap/Container';
import { LinkModel } from '../../models/globals';

interface BreadcrumbProps {
    backToPreviousViewLink?: LinkModel;
    current: string;
    showBreadcrumbs: boolean;
    trailLinks: LinkModel[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ backToPreviousViewLink, current, showBreadcrumbs, trailLinks }) => {
    const linkProps = { className: 'text-primary' };
    const listProps = { className: 'bg-transparent mb-0' };

    if (!showBreadcrumbs) return null;

    return (
        <Container>
            {/* Compact version for small screen widths */}
            {!!backToPreviousViewLink && (
                <div className="d-sm-none">
                    <BootstrapBreadcrumb listProps={listProps}>
                        <BootstrapBreadcrumb.Item
                            aria-label={`breadcrumb: ${backToPreviousViewLink.name}`}
                            href={backToPreviousViewLink.url}
                            linkProps={linkProps}
                        >
                            {backToPreviousViewLink.name}
                        </BootstrapBreadcrumb.Item>
                    </BootstrapBreadcrumb>
                </div>
            )}

            {/* Regular version for all screen-widths bigger than small */}
            <div className="d-none d-sm-block">
                <BootstrapBreadcrumb listProps={listProps}>
                    {trailLinks.map(({ name, url }) => (
                        <BootstrapBreadcrumb.Item
                            aria-label={`breadcrumb: ${name}`}
                            href={url}
                            key={url}
                            linkProps={linkProps}
                        >
                            {name}
                        </BootstrapBreadcrumb.Item>
                    ))}
                    <BootstrapBreadcrumb.Item active aria-label={`breadcrumb: ${current}`} className="text-dark">
                        {current}
                    </BootstrapBreadcrumb.Item>
                </BootstrapBreadcrumb>
            </div>
        </Container>
    );
};

export { Breadcrumb, BreadcrumbProps };
